import classNames from "classnames";
import { JorneyToHomeArea } from "views/j2h/JorneyToHomeReducer";
import React from "react";
import { useTranslation } from "react-i18next";

type AreaTargetButtonProps = {
  hidden: boolean;
  selected: boolean;
  disable: boolean;
  here: boolean;
  icon: string;
  area: JorneyToHomeArea;
  color: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

function AreaTargetButton({
  hidden,
  selected,
  disable,
  here,
  icon,
  area,
  color,
  onClick,
}: AreaTargetButtonProps) {
  const { t } = useTranslation();
  return (
    <div
      className={classNames("flex flex-col justify-center", { hidden: hidden })}
    >
      <div
        className={`${selected ? "" : "invisible"} ml-auto mr-auto flex h-8`}
      >
        <i className="fas fa-location-dot text-green-500" />
      </div>
      <button
        className={classNames(
          `${selected ? "scale-[1.02]" : "scale-[0.95]"} ${
            disable || here ? "disable opacity-[0.5]" : "cursor-pointer"
          } relative w-full h-full mt-1 py-1 rounded-lg font-medium !rounded-button transition-all duration-200 flex flex-col items-center justify-center text-base shadow-lg text-white bg-blue-600 destination-button ${color}`
        )}
        disabled={disable}
        onClick={onClick}
      >
        {/* Area name */}
        <div className={`flex items-center justify-center`}>
          <i className={`fas ${icon} mr-2 fa-xs`} />
          {t("J2H." + JorneyToHomeArea[area])}
        </div>
        {/* current players */}
        {/* <div
          className={classNames("flex items-center justify-center text-sm", {
            hidden: gameOver,
          })}
        >
          <i className={`fas fa-users mr-2 fa-xs`} />
          {areaState}
        </div> */}
      </button>
    </div>
  );
}

export default AreaTargetButton;
